import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const collapseInfoSectionSelector = createSelector(testTargetOffersSelector, offers => offers.collapseInfoSection || Empty.Object);

export { collapseInfoSectionSelector };
